//
import axios from 'axios'

//
import ProviderModel from '@/models/Purchase/PchProvider'
import { addRUTHyphen, removeRUTHyphen } from '@/services/RUTFormatter'
import API from '@/services/api/api'
import PchInvoiceMdl from '@/models/Purchase/PchPurchaseInvoice'
import InvoiceIncludes from '@/views/provider/include/InvoiceIncludes'
/**
 *
 */
const deleteProvider = async function(id) {
    //
    console.log(API.PCH_PROVIDER, 'provider')
    try {
        //
        let response = await axios.delete(`${API.PCH_PROVIDER}/${id}`)

        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

const fetchAll = async function() {
    try {
        let customers = await ProviderModel.append('branch_offices').get()
        return customers.data
    } catch (error) {
        return error.response.data
    }
}

const fetchAllAvailableGroundSeller = async function() {
    try {
        let customers = await ProviderModel.append('branch_offices')
            .where('is_available_ground_seller', 1)
            .get()
        return customers.data
    } catch (error) {
        return error.response.data
    }
}

const fetchProvider = async function(id) {
    try {
        let customer = await ProviderModel.append('branch_offices').find(id)
        return customer
    } catch (error) {
        return error.response.data
    }
}

const updateProvider = async function(id, data) {
    //
    try {
        //
        let customer = await fetchProvider(id)
        //
        customer.rut = addRUTHyphen(data.rut)
        customer.alias_name = data.alias_name
        customer.business_name = data.business_name
        customer.branch_offices = data.branch_offices
        customer.is_pyme = data.is_pyme

        //
        let response = await customer.save()
        //
        return response
    } catch (error) {
        //
        return error.response.data
    }
}

const createProvider = async function(data) {
    try {
        let customer = new ProviderModel(data)
        let response = await customer.save()
        return response
    } catch (error) {
        return error.response.data
    }
}

const fetchProviderCatalogue = async function(idProvider) {
    try {
        let customer = await ProviderModel.append('product_catalogue').find(
            idProvider
        )
        return customer
    } catch (error) {
        return error.response.data
    }
}

const fetchProviderInvoice = async function(idInvoice) {
    try {
        let invoice = await PchInvoiceMdl.include([...InvoiceIncludes]).find(
            idInvoice
        )
        return invoice
    } catch (error) {
        return error.response.data
    }
}

const linkProductToProduct = async function(id, data) {
    //
    try {
        //
        let response = await axios.post(
            process.env.VUE_APP_API_ROUTE + `/pch_provider/${id}/add_products`,
            data
        )

        //
        return response
    } catch (error) {
        //
        //console.log( error )

        //
        return error.response.data
    }
}

export default {
    deleteProvider,
    fetchAll,
    fetchAllAvailableGroundSeller,
    fetchProvider,
    updateProvider,
    createProvider,
    fetchProviderCatalogue,
    fetchProviderInvoice,
    linkProductToProduct,
}
